/**
 * Ayuda — Productos → Grupos de Artículos
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_PRO_ARTICLE_GROUPS_ITEM = {
  id: 'articleGroups',
  screenId: 'adm-pro-article-groups',
  label: 'Grupos de Artículos',
  description: 'Clasificá productos en grupos.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Los grupos organizan los artículos (por rubro, línea, familia, etc.). Después podés filtrar artículos por grupo y usarlos en promociones o reportes.',
      },
      {
        title: 'Ver la lista',
        bullets: [
          'Columnas: Código, Descripción, Estado.',
          '«Solo activos» filtra grupos en uso.',
          'Tocá una fila para ver; el lápiz para editar.',
        ],
      },
      {
        title: 'Cargar un grupo nuevo',
        fields: [
          { label: 'Descripción', description: 'Nombre del grupo. Obligatorio.' },
          { label: 'Activo', description: 'Si está disponible para asignar a artículos.' },
          { label: 'Observaciones', description: 'Notas opcionales.' },
        ],
      },
      {
        title: 'Uso con artículos',
        intro: 'Al crear o editar un artículo (menú Artículos), en la sección «Grupos» marcás a cuáles pertenece.',
      },
    ],
  },
}
